import React from 'react'

export const CurrentAxisContext = React.createContext({
  currentAxisColor: null,
  handleAxisChange: () => {}
})